import { render, staticRenderFns } from "./jihuoka.vue?vue&type=template&id=35696db3&scoped=true"
import script from "./jihuoka.vue?vue&type=script&lang=js"
export * from "./jihuoka.vue?vue&type=script&lang=js"
import style0 from "./jihuoka.vue?vue&type=style&index=0&id=35696db3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35696db3",
  null
  
)

export default component.exports